import { get, startCase } from 'lodash';
import { formatTimelineChangeItems } from 'common/Workqueue/timelineEventUtils';
import { ENROLLMENT_STATUSES } from '../constants';

const NOISY_CHANGE_FIELDS = ['created_at', 'updated_at', 'id', 'metadata'];
const HANDLED_RELATIONSHIP_FIELDS = [
  'enrollment_review_reason_id',
  'enrollment_rejection_reason_id',
];

const STATUS_TO_LABEL = {
  [ENROLLMENT_STATUSES.open]: 'Open',
  [ENROLLMENT_STATUSES.inReview]: 'In Review',
  [ENROLLMENT_STATUSES.accepted]: 'Accepted',
  [ENROLLMENT_STATUSES.rejected]: 'Rejected',
  [ENROLLMENT_STATUSES.canceled]: 'Canceled',
};

export const STATUS_TO_ICON = {
  [ENROLLMENT_STATUSES.open]: 'IconPencil',
  [ENROLLMENT_STATUSES.inReview]: 'IconFileText',
  [ENROLLMENT_STATUSES.accepted]: 'IconCheckCircle',
  [ENROLLMENT_STATUSES.rejected]: 'IconCrossCircleV2',
  [ENROLLMENT_STATUSES.canceled]: 'IconMinusCircle',
};

export const getStatusLabel = (status) => STATUS_TO_LABEL[status] || startCase(status);

export const getMeaningfulChangeKeys = (eventChanges) => (
  eventChanges
    .map((change) => change.field_name)
    .filter((fieldName) => !NOISY_CHANGE_FIELDS.includes(fieldName))
);

export const buildTimelineEventDetailItems = (timelineEvent, shouldIncludeStatus = true) => {
  const additionalData = get(timelineEvent, 'additional_data', {});
  const eventChanges = get(timelineEvent, 'changes', []);
  return formatTimelineChangeItems({
    eventChanges,
    additionalData,
    excludedFieldNames: [
      ...NOISY_CHANGE_FIELDS,
      ...HANDLED_RELATIONSHIP_FIELDS,
      'short_id',
      ...(shouldIncludeStatus ? [] : ['enrollment_status']),
    ],
    additionalDataFields: ['review_reason', 'rejection_reason'],
    noteFieldNames: ['in_review_note', 'rejection_note', 'disenroll_note'],
    labelOverrides: {
      enrollment_status: 'Status',
    },
  }).map((item) => {
    if (item.label === 'Status') {
      return { ...item, value: getStatusLabel(item.value.toLowerCase().replace(/\s+/g, '_')) };
    }

    return item;
  });
};
